module.exports = __webpack_public_path__ + "static/media/new-grey-drop-down-arrow.889b86ba.svg";